// Seasonal theme decorations (super-admin toggle). Full-send Halloween:
// recolour + floating bats + corner cobwebs + spooky display font.
// Everything here is purely visual and pointer-events-none so it never blocks
// taps or breaks any workflow.

// Toggles the <html> class + loads the spooky display font once when needed.
export function applySeasonalTheme(theme) {
  const root = document.documentElement;
  ["halloween"].forEach((t) => root.classList.toggle(`theme-${t}`, theme === t));
  if (theme === "halloween" && !document.getElementById("fl-creepster")) {
    const link = document.createElement("link");
    link.id = "fl-creepster";
    link.rel = "stylesheet";
    link.href = "https://fonts.googleapis.com/css2?family=Creepster&display=swap";
    document.head.appendChild(link);
  }
}

const Bat = ({ className, style }) => (
  <svg className={className} style={style} viewBox="0 0 64 40" width="54" height="34" aria-hidden="true">
    <g className="fl-bat-body" fill="#15101f">
      <path d="M32 12c2-6 6-9 10-9-2 3-1 6 1 7 3-5 9-7 14-5-4 1-6 4-6 8 3-2 7-2 9 1-5 0-8 3-10 8-3-6-8-9-14-9h-8c-6 0-11 3-14 9-2-5-5-8-10-8 2-3 6-3 9-1 0-4-2-7-6-8 5-2 11 0 14 5 2-1 3-4 1-7 4 0 8 3 10 9z"/>
    </g>
  </svg>
);

const Cobweb = ({ className }) => (
  <svg className={className} viewBox="0 0 120 120" width="120" height="120" aria-hidden="true"
       fill="none" stroke="rgba(255,255,255,0.22)" strokeWidth="1.2">
    <path d="M0 0 L120 120 M0 0 L120 40 M0 0 L40 120 M0 0 L85 20 M0 0 L20 85" />
    <path d="M20 20 Q40 10 55 25 M20 20 Q10 40 25 55 M38 38 Q62 20 80 40 M38 38 Q20 62 40 80" />
  </svg>
);

export function SeasonalDecor({ theme }) {
  if (theme !== "halloween") return null;
  return (
    <div aria-hidden="true" className="fl-season-decor" data-testid="seasonal-decor-halloween">
      <Cobweb className="fl-cobweb fl-cobweb-tl" />
      <Cobweb className="fl-cobweb fl-cobweb-tr" />
      <div className="fl-bat-track fl-bat-track-1"><Bat className="fl-bat" /></div>
      <div className="fl-bat-track fl-bat-track-2"><Bat className="fl-bat" style={{ width: 38, height: 24 }} /></div>
      <div className="fl-bat-track fl-bat-track-3"><Bat className="fl-bat" style={{ width: 68, height: 42 }} /></div>
    </div>
  );
}
